import { AppTypes } from "../enums";

export class UserLogoutRequest
{
    public login_token: string = '';
    public readonly app_type : number = AppTypes.Web; // Default to Web
    public login_user_id:number = 0;
    // public LastSelectedChapterRef: number = 0;
    // public LastSelectedSubChapterRef: number = 0;
}
